export const COLORS = {
  long: '#2EBD85',
  short: '#F6465D',
  tp: '#2EBD85',
  sl: '#F6465D',
  hedge: '#F47515',
  panel: '#26A69A',
  placeholder: '#818181',
  /** 다크 모드 박스 배경색 */
  bgDark: '#1f1f1f',
  /** 라이트 모드 박스 배경색 */
  bgLight: '#FFFFFF',
} as const;
